export enum EIntercomEvent {
  CREATE_REMINDER = 'create_reminder',
  CREATE_RECURRING_REMINDER = 'create_recurring_reminder',
  CREATE_SAVED_VIEW = 'create_saved_view',
}
